import { createFileRoute, Outlet, useNavigate, useRouter } from "@tanstack/react-router";
import { Button, Modal } from "@heroui/react";
import {
  TemplateProtectionGuidelinesProvider,
  useTemplateProtectionGuidelines,
} from "@repo/context/template-protection-guidelines";
import { SafeAreaContainer } from "@/components/layout/safe-area-container";

export const Route = createFileRoute("/template_protections/blacklist")({
  component: BlacklistLayout,
});

function BlacklistLayout() {
  return (
    <TemplateProtectionGuidelinesProvider>
      <SafeAreaContainer className="bg-surface" customPaddingBottom="2rem">
        <BlacklistLayoutInner />
      </SafeAreaContainer>
    </TemplateProtectionGuidelinesProvider>
  );
}

function BlacklistLayoutInner() {
  const { hasAgreedToGuidelines, setHasAgreedToGuidelines } =
    useTemplateProtectionGuidelines();
  const navigate = useNavigate();
  const router = useRouter();

  const handleDisagree = () => {
    if (window.history.length > 1) {
      router.history.back();
      return;
    }
    void navigate({
      to: "/template_protections",
      search: { tab: "mine" },
    });
  };

  const handleAgree = () => {
    setHasAgreedToGuidelines(true);
  };

  return (
    <div className="flex min-h-full flex-col">
      <Outlet />

      <Modal.Backdrop
        isOpen={!hasAgreedToGuidelines}
        isDismissable={false}
        isKeyboardDismissDisabled
      >
        <Modal.Container size="lg" scroll="inside">
          <Modal.Dialog className="outline-none">
            <Modal.Header>
              <Modal.Heading>使用准则</Modal.Heading>
            </Modal.Header>
            <Modal.Body className="flex flex-col gap-3">
              <p className="text-sm text-default-500">
                首次使用黑名单功能前，请您先阅读《兽聚汇标记机黑名单使用准则》并同意以下使用准则。
              </p>
              <iframe
                src="https://www.furries.cn/terms/template-guard"
                className="w-full h-[350px] border-0"
                title="使用准则"
              />
            </Modal.Body>
            <Modal.Footer className="flex w-full flex-row gap-3">
              <Button
                className="flex-1 rounded-full"
                variant="secondary"
                onPress={handleDisagree}
              >
                我不同意
              </Button>
              <Button
                className="flex-1 rounded-full"
                variant="primary"
                onPress={handleAgree}
              >
                我同意
              </Button>
            </Modal.Footer>
          </Modal.Dialog>
        </Modal.Container>
      </Modal.Backdrop>
    </div>
  );
}
